'use strict';

// package version injected by `npm run preprocess`
exports.version = '3.1.0';
